// extracted by mini-css-extract-plugin
export default {"productCarousel":"M0-z"};